import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { errorBoundary, sendTelemetryErrorEvent } from '../../../common/react/components/ErrorBoundary';
import { clearSpaceContentCountsAction } from '../../actions/spaces/ContentCountsActions';
import { showContentTypes } from '../../actions/spaces/ContentExplorerFilterActions';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { selectCurrentlyApplicableContentTypes, selectDefaultContentTypeFilterValues } from '../../selectors/ContentFilterSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps,MapStateToProps } from '../../utils/ConnectUtils';
import {
  SharedWithMeSpace,
  SharedWithMeSpaceDispatchProps,
  SharedWithMeSpaceOwnProps,
  SharedWithMeSpaceStateProps} from './SharedWithMeSpace';

const mapStateToProps: MapStateToProps<SharedWithMeSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<SharedWithMeSpaceDispatchProps> = (dispatch) =>
  bindActionCreators({
    filterSelected: showContentTypes,
    requestSpaceContents,
    clearContentCounts: clearSpaceContentCountsAction
  }, dispatch);

const ConnectedSharedWithMeSpaceInternal: React.ComponentClass<SharedWithMeSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(SharedWithMeSpace);

export const ConnectedSharedWithMeSpace = errorBoundary<SharedWithMeSpaceOwnProps>
  (sendTelemetryErrorEvent)(ConnectedSharedWithMeSpaceInternal);
